
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93s3HzIB7nGtMeta } from "/tmp/menaceking-build-1753204313/pages/[...slug].vue?macro=true";
import { default as autologinbMMJir3eW5Meta } from "/tmp/menaceking-build-1753204313/pages/auth/autologin.vue?macro=true";
import { default as callback0xn2k4zGpmMeta } from "/tmp/menaceking-build-1753204313/pages/auth/social/[connection]/callback.vue?macro=true";
import { default as betting9bXnGA9qyqMeta } from "/tmp/menaceking-build-1753204313/pages/betting.vue?macro=true";
import { default as _91pageIdentity_93BDOAhcOpIcMeta } from "/tmp/menaceking-build-1753204313/pages/bonus/[pageIdentity].vue?macro=true";
import { default as _91categoryIdentity_938c1XDIQrlrMeta } from "/tmp/menaceking-build-1753204313/pages/categories/[categoryIdentity].vue?macro=true";
import { default as categoriess7KEkGbywEMeta } from "/tmp/menaceking-build-1753204313/pages/categories.vue?macro=true";
import { default as contactv4Bhg2jMMfMeta } from "/tmp/menaceking-build-1753204313/pages/contact.vue?macro=true";
import { default as favorites_46clientqngnnZgqapMeta } from "/tmp/menaceking-build-1753204313/pages/favorites.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/tmp/menaceking-build-1753204313/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91id_93g9KMGxnTmVMeta } from "/tmp/menaceking-build-1753204313/pages/games/[id].vue?macro=true";
import { default as indexzGRse8380tMeta } from "/tmp/menaceking-build-1753204313/pages/index.vue?macro=true";
import { default as loyalty0ySbneP2MnMeta } from "/tmp/menaceking-build-1753204313/pages/loyalty.vue?macro=true";
import { default as mainR4khAaHlKSMeta } from "/tmp/menaceking-build-1753204313/pages/main.vue?macro=true";
import { default as bonusesGIUxunzlm9Meta } from "/tmp/menaceking-build-1753204313/pages/profile/bonuses.vue?macro=true";
import { default as documentsEgnj3B1FNfMeta } from "/tmp/menaceking-build-1753204313/pages/profile/documents.vue?macro=true";
import { default as history5wKAwoa8AEMeta } from "/tmp/menaceking-build-1753204313/pages/profile/history.vue?macro=true";
import { default as info1dG1BtBcYpMeta } from "/tmp/menaceking-build-1753204313/pages/profile/info.vue?macro=true";
import { default as limitsjh1J8vJvOqMeta } from "/tmp/menaceking-build-1753204313/pages/profile/limits.vue?macro=true";
import { default as notificationszUohgAh7yyMeta } from "/tmp/menaceking-build-1753204313/pages/profile/notifications.vue?macro=true";
import { default as securityqea3JmuvuMMeta } from "/tmp/menaceking-build-1753204313/pages/profile/security.vue?macro=true";
import { default as verificationYRFlbEPmZWMeta } from "/tmp/menaceking-build-1753204313/pages/profile/verification.vue?macro=true";
import { default as wallet_45test_45v2WAsNdh02LoMeta } from "/tmp/menaceking-build-1753204313/pages/profile/wallet-test-v2.vue?macro=true";
import { default as walletsLTCsxpSSnMeta } from "/tmp/menaceking-build-1753204313/pages/profile/wallet.vue?macro=true";
import { default as profile_46clientdmaJo0RdqHMeta } from "/tmp/menaceking-build-1753204313/pages/profile.client.vue?macro=true";
import { default as providersT0O8ayAjIRMeta } from "/tmp/menaceking-build-1753204313/pages/providers.vue?macro=true";
import { default as _91pageIdentity_93NA3zXRcYlCMeta } from "/tmp/menaceking-build-1753204313/pages/questions/[pageIdentity].vue?macro=true";
import { default as questions7RXCG9mdvaMeta } from "/tmp/menaceking-build-1753204313/pages/questions.vue?macro=true";
import { default as recently_45played_46clientVYEOeW5x9VMeta } from "/tmp/menaceking-build-1753204313/pages/recently-played.client.vue?macro=true";
import { default as _91pageIdentity_93Un7RaIQWMRMeta } from "/tmp/menaceking-build-1753204313/pages/static/[pageIdentity].vue?macro=true";
import { default as _91identity_93I3429fImdyMeta } from "/tmp/menaceking-build-1753204313/pages/tournaments/[identity].vue?macro=true";
import { default as indexRdGv4Oo6ggMeta } from "/tmp/menaceking-build-1753204313/pages/tournaments/index.vue?macro=true";
import { default as welcome_45packagemJkkEBH5APMeta } from "/tmp/menaceking-build-1753204313/pages/welcome-package.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/tmp/menaceking-build-1753204313/pages/[...slug].vue")
  },
  {
    name: "auth-autologin",
    path: "/auth/autologin",
    component: () => import("/tmp/menaceking-build-1753204313/pages/auth/autologin.vue")
  },
  {
    name: "auth-social-connection-callback",
    path: "/auth/social/:connection()/callback",
    component: () => import("/tmp/menaceking-build-1753204313/pages/auth/social/[connection]/callback.vue")
  },
  {
    name: "betting",
    path: "/betting",
    component: () => import("/tmp/menaceking-build-1753204313/pages/betting.vue")
  },
  {
    name: "bonus-pageIdentity",
    path: "/bonus/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1753204313/pages/bonus/[pageIdentity].vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: categoriess7KEkGbywEMeta || {},
    component: () => import("/tmp/menaceking-build-1753204313/pages/categories.vue"),
    children: [
  {
    name: "categories-categoryIdentity",
    path: ":categoryIdentity()",
    component: () => import("/tmp/menaceking-build-1753204313/pages/categories/[categoryIdentity].vue")
  }
]
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/tmp/menaceking-build-1753204313/pages/contact.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1753204313/pages/favorites.client.vue"))
  },
  {
    name: "games-id",
    path: "/games/:id()",
    component: () => import("/tmp/menaceking-build-1753204313/pages/games/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/menaceking-build-1753204313/pages/index.vue")
  },
  {
    name: "loyalty",
    path: "/loyalty",
    component: () => import("/tmp/menaceking-build-1753204313/pages/loyalty.vue")
  },
  {
    name: "main",
    path: "/main",
    component: () => import("/tmp/menaceking-build-1753204313/pages/main.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1753204313/pages/profile.client.vue")),
    children: [
  {
    name: "profile-bonuses",
    path: "bonuses",
    component: () => import("/tmp/menaceking-build-1753204313/pages/profile/bonuses.vue")
  },
  {
    name: "profile-documents",
    path: "documents",
    component: () => import("/tmp/menaceking-build-1753204313/pages/profile/documents.vue")
  },
  {
    name: "profile-history",
    path: "history",
    component: () => import("/tmp/menaceking-build-1753204313/pages/profile/history.vue")
  },
  {
    name: "profile-info",
    path: "info",
    component: () => import("/tmp/menaceking-build-1753204313/pages/profile/info.vue")
  },
  {
    name: "profile-limits",
    path: "limits",
    component: () => import("/tmp/menaceking-build-1753204313/pages/profile/limits.vue")
  },
  {
    name: "profile-notifications",
    path: "notifications",
    component: () => import("/tmp/menaceking-build-1753204313/pages/profile/notifications.vue")
  },
  {
    name: "profile-security",
    path: "security",
    component: () => import("/tmp/menaceking-build-1753204313/pages/profile/security.vue")
  },
  {
    name: "profile-verification",
    path: "verification",
    component: () => import("/tmp/menaceking-build-1753204313/pages/profile/verification.vue")
  },
  {
    name: "profile-wallet-test-v2",
    path: "wallet-test-v2",
    component: () => import("/tmp/menaceking-build-1753204313/pages/profile/wallet-test-v2.vue")
  },
  {
    name: "profile-wallet",
    path: "wallet",
    component: () => import("/tmp/menaceking-build-1753204313/pages/profile/wallet.vue")
  }
]
  },
  {
    name: "providers",
    path: "/providers",
    component: () => import("/tmp/menaceking-build-1753204313/pages/providers.vue")
  },
  {
    name: "questions",
    path: "/questions",
    meta: questions7RXCG9mdvaMeta || {},
    component: () => import("/tmp/menaceking-build-1753204313/pages/questions.vue"),
    children: [
  {
    name: "questions-pageIdentity",
    path: ":pageIdentity()",
    component: () => import("/tmp/menaceking-build-1753204313/pages/questions/[pageIdentity].vue")
  }
]
  },
  {
    name: "recently-played",
    path: "/recently-played",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1753204313/pages/recently-played.client.vue"))
  },
  {
    name: "static-pageIdentity",
    path: "/static/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1753204313/pages/static/[pageIdentity].vue")
  },
  {
    name: "tournaments-identity",
    path: "/tournaments/:identity()",
    component: () => import("/tmp/menaceking-build-1753204313/pages/tournaments/[identity].vue")
  },
  {
    name: "tournaments",
    path: "/tournaments",
    component: () => import("/tmp/menaceking-build-1753204313/pages/tournaments/index.vue")
  },
  {
    name: "welcome-package",
    path: "/welcome-package",
    component: () => import("/tmp/menaceking-build-1753204313/pages/welcome-package.vue")
  }
]